import { useQueryParams } from "./useQueryParams";

export function useFilter() {
  const { setQueryParam } = useQueryParams();
  const leadWebsiteFilter = (statusId, officeId, mitraId, purpose, from, to) => {
    if(statusId) setQueryParam("status", statusId);
    if(officeId) setQueryParam("office_id", officeId);
    if(mitraId) setQueryParam("mitra_id", mitraId);
    if(purpose) setQueryParam("purpose", purpose);
    if(from) setQueryParam("from", from);
    if(to) setQueryParam("to", to);
  };

  return {
    leadWebsiteFilter,
  };
}
